<template>
  <div>
    <aside class="leftbar material-leftbar">
      <!--  SideBar Top Section -->
      <div class="left-aside-container">
      	<div class="user-profile-container">
          <div class="user-profile clearfix">
            <!-- <div class="admin-user-thumb">
              <img class="pointer" v-if="!user.profile_pic" @click="GoUserProfile" src="../../assets/img/logo1.png" alt="admin">
              <img class="pointer" v-else @click="GoUserProfile" :src="user.profile_pic" alt="admin">
            </div> -->
            <div class="admin-user-info">
              <ul class="pointer">
                <li><h4 class="text-white">{{currentTime}} <small class="text-white" v-tooltip="'這些都是我愛的名言，說不定會有一句話突然點醒你、或給你滿滿的力量，找回最初打拼的感覺 - Flowneat創辦人 Tim'"><i class="fas fa-question"></i></small></h4></li>
                <li>
                	<p class="pointer" style="color: #fff; line-height: 2.2rem" @click="changeSentence()">{{sentence_now.word}}  <span style="background: #fff;color: #222 ;padding:2px; white-space: nowrap;">{{sentence_now.from}}</span></p>
                </li>
              </ul>
            </div>
          </div>
	      </div>
        <ul class="list-accordion tree-style text-left">
          <li class="pointer" @click="GoDashbaord()">
            <a><i class="fa fa-file-invoice-dollar"></i><span class="list-label v-step-0-1">交易管理</span></a>
          </li>
          <li class="pointer" @click="GoContact() ">
            <a><i class="fa fa-user"></i><span class="list-label">客戶管理</span></a>
          </li>
          <li class="pointer" @click="GoOrganization()">
            <a ><i class="fa fa-building"></i><span class="list-label">客戶公司</span></a>
          </li>
          <!-- <li class="pointer">
            <a ><i class="fas fa-wrench"></i><span class="list-label">外包管理</span></a>
          </li> -->
          <!-- <li class="pointer" @click="GoProjectsListBoard()"s>
            <a ><i class="fab fa-flipboard"></i><span class="list-label">專案管理</span></a>
          </li> -->
          <!-- <li class="pointer" @click="GoActivity()">
            <a ><i class="far fa-calendar-alt"></i><span class="list-label">代辦事項</span></a>
          </li> -->
          <li class="pointer" @click="GoFinances()">
            <a ><i class="fas fa-dollar-sign"></i><span class="list-label">帳務管理</span></a>
          </li>
          <li class="pointer" @click="GoProduct()">
            <a ><i class="fas fa-server"></i><span class="list-label">服務項目</span></a>
          </li>
          <!-- <li class="pointer" @click="GoKnowledgeBase()">
            <a ><i class="fas fa-book"></i><span class="list-label">知識庫</span></a>
          </li> -->
          <!-- <li class="pointer" @click="GoAnalyticsSales()">
            <a ><i class="fas fa-chart-line"></i><span class="list-label">分析</span></a>
          </li> -->
          <li v-if="user.permission == 'admin'" class="list-title">管理員</li>
          <li v-if="user.permission == 'admin'" class="pointer" @click="GoMembers()">
            <a ><i class="fa fa-users"></i><span class="list-label">成員設定</span></a>
          </li>
          <li  v-if="user.permission == 'admin'" class="pointer" @click="GoCompany()">
            <a ><i class="fas fa-info"></i><span class="list-label">公司基本資料</span></a>
          </li>
        </ul>
      </div>
    </aside>
  </div>
</template>
<script>
import { getCookie } from '../../assets/js/elffy_js/cookie.js'
import moment from 'moment';
export default {
  name: 'LeftSideBar',
  data() {
    return {
      currentTime: '',
      sentences: [],
      sentence_now: {},
    }
  },
  created() {
    this.currentTime = moment().format('LTS');
    this.getSentences()
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
    setInterval(() => this.changeSentence(), 3600 * 1000);
  },
  props: ['user'],
  computed: {
    
  },
  methods: {
  	updateCurrentTime() {
      this.currentTime = moment().format('LTS');
    },
    logout() {
      const vm = this;
      this.axios.delete('sessions').then(
        function(response) {
          if (response.status == 200) {
            var date = new Date();
            date.setTime(date.getTime() + (1))
            document.cookie = 'auth_token=' + getCookie('auth_token') + ";" + 'expires=' + date.toUTCString() + ";path=/";
            document.cookie = 'aside_bar=' + getCookie('aside_bar') + ";" + 'expires=' + date.toUTCString() + ";path=/";
            document.cookie = 'filter_deal_owner=' + getCookie('filter_deal_owner') + ";" + 'expires=' + date.toUTCString() + ";path=/";
            document.cookie = 'deal_filter=' + getCookie('deal_filter') + ";" + 'expires=' + date.toUTCString() + ";path=/";
            vm.$router.push('/login')
          } else {
            console.log('error:', 'User Logout Fail')
          }
        })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    
    GoDashbaord() {
      this.$router.push('/dashboard')
    },
    GoMembers() {
      this.$router.push('/setting/members')
    },
    GoCompany() {
      this.$router.push('/setting/company')
    },
    GoDashbaord() {
      this.$router.push('/dashboard')
    },
    GoActivity() {
      this.$router.push('/activities')
    },
    GoOrganization() {
      this.$router.push('/organizations')
    },
    GoContact() {
      this.$router.push('/contacts')
    },
    GoProduct() {
      this.$router.push('/products')
    },
    GoSetting() {
      this.$router.push('/setting')
    },
    GoAnalyticsSales() {
      this.$router.push('/analytics/sales')
    },
    GoAnalyticsClients() {
      this.$router.push('/analytics/clients')
    },
    GoFinances() {
      this.$router.push('/finances/finance_list')
    },
    GoProjectsListBoard() {
    	this.$router.push('/projects_list_board')
    },
    GoKnowledgeBase() {
    	this.$router.push('/knowledge_base')
    },
    changeSentence(){
    	this.sentence_now = this.sentences[Math.floor(Math.random() * this.sentences.length)]
    },
    getSentences(){
    	this.sentences = [
    		{'word': '拋棄別人幫你設定的尺，重建自我價值觀，找自己的路。','from': '大前研一'},
    		{'word': '沒有什麼風險是會真的死得了人的，所以，有什麼好怕的呢？', 'from':'詹宏志'},
    		{'word': "I can accept failure, everyone fails at something. But I can't accept not trying", 'from':'Michael Jordan'},
    		{'word': "Your time is limited, so don’t waste it living someone else’s life.", 'from':'Steve Jobs'},
    		{'word': "Don’t let the noise of others’ opinions drown out your own inner voice.", 'from':'Steve Jobs'},
    		{'word': "Stay hungry. Stay foolish.", 'from':'Steve Jobs'},
    		{'word': "If today were the last day of your life, would you want to do what you are about to do today", 'from':'Steve Jobs'},
    		{'word': "I think the things you regret most in life are the things you didn’t do.", 'from':'Steve Jobs'},
    		{'word': "We’re here to put a dent in the universe. Otherwise why else even be here?", 'from':'Steve Jobs'},
    		{'word': "Innovation distinguishes between a leader and a follower.", 'from':'Steve Jobs'},
    		{'word': "失敗在這裡，是一個選項。如果凡事順利成功，那很可能表示創新不足", 'from':'Elon Musk'},
    		{'word': "如果某件事情的重要性毋庸置疑，即使全世界都不站在你這一方，你依然得堅持下去", 'from':'Elon Musk'},
    		{'word': "與時俱進，才能創造未來。當你覺得值得挑戰的時候，不要失去毅力", 'from':'劉金標（巨大機械董事長）'},
    		{'word': "很多人一開始為了夢想而忙，後來忙得忘了夢想", 'from':''},
    		{'word': "用人不在於如何減少人的短處，而在於如何發揮人的長處", 'from':'彼得·杜拉克'},
    		{'word': "企業最大的資產是人", 'from':'松下幸之助'},
    		{'word': "員工培訓是企業風險最小，收益最大的戰略性投資", 'from':'沃倫·貝尼斯'},
    		{'word': "品質是維護顧客忠誠的最好保證", 'from':'通用電氣-傑克·韋爾奇'},
    		{'word': "不創新，就滅亡", 'from':'亨利·福特'},
    		{'word': "創新是做大公司的惟一之路", 'from':'管理大師傑弗里'},
    		{'word': "管理就是溝通、溝通再溝通", 'from':'通用電氣-傑克·韋爾奇'},
    		{'word': "不善於傾聽不同的聲音，是管理者最大的疏忽", 'from':'美國女企業家瑪麗·凱'},
    		{'word': "企業管理過去是溝通，現在是溝通，未來還是溝通", 'from':'松下幸之助'},
    		{'word': "世界上每100家破產倒閉的大企業中，85%是因為企業管理者的決策不慎造成的", 'from':'蘭德公司'},
    		{'word': "一個成功的決策，等於90%的信息加上10%的直覺", 'from':'S·M·沃爾森'},
    		{'word': "決不能在沒有選擇的情況下，作出重大決策", 'from':'克萊斯勒總裁 李·艾柯卡'},
    		{'word': "自始至終把人放在第一位，尊重員工是成功的關鍵", 'from':'IBM創始人托馬斯·沃森'},
    		{'word': "是員工養活了公司", 'from':'李嘉誠'},
    		{'word': "管得少，就是管得好", 'from':'通用電氣 傑克·韋爾奇'},
    		{'word': "為顧客節省每一分錢", 'from':'沃爾瑪創始人 山姆·沃爾頓'},
    		{'word': "經營管理，成本分析，要追根究底，分析到最後一點", 'from':'王永慶'},
    		{'word': "把你的競爭對手視為對手而非敵人，將會更有益", 'from':'羅莎貝斯·莫斯·坎特'},
    		{'word': "我今天就要打敗你，我不睡覺也要打敗你，這是我們的文化", 'from':'甲骨文 胡伯林'},
    		{'word': "新經濟時代，不是大魚吃小魚，而是快魚吃慢魚", 'from':'美國思科公司總裁錢伯斯'},
    		{'word': "差錯發生在細節，成功取決於系統", 'from':'馬瑞特總裁 比爾·馬瑞特'},
    		{'word': "三流的點子加一流的執行力，永遠比一流的點子加三流的執行力更好。", 'from':'軟銀公司 孫正義'},
    		{'word': "微軟離破產永遠只有18個月 - 危機管理", 'from':'比爾·蓋茨'},
    		{'word': "21世紀，沒有危機感是最大的危機", 'from':'哈佛商學院教授'},
    		{'word': "獎勵什麼，就會得到什麼", 'from':'管理專家米契爾·拉伯福'},
    		{'word': "給予的永遠要超出別人的預期", 'from':'Google 共同創辦人 賴利·佩吉'},
    		{'word': "你如果想創造一個好的產品，鎖定一個人為目標客戶，確定那個人得到最棒的體驗。", 'from':'Brian Chesky, Airbnb Co-founder'},



    	]
    	this.changeSentence()
    }
  }
}
</script>


// WEBPACK FOOTER //
// LeftSideBar.vue?527728d1